export default {
  '_b._qhyy': 'Skift sprog',
  '_a._jzz': 'Indlæser...',
  '_a._jzgd': 'Indlæs mere',
  '_a._wct': 'Velkommen',
  '_a._gd': 'Mere',
  '_a._bf': 'Afspil',
  '_a._bcz': 'Gemmer...',
  '_a._sctp': 'Upload billede',
  '_dl._qssyx': 'Indtast venligst din e-mailadresse',
  '_dl._qssmm': 'Indtast venligst din adgangskode',
  '_dl._ann': 'Log ind',
  '_dl._hmyzh': 'Har du ikke en konto?',
  '_dl._qzc': 'Registrer',
  '_dl._yzhl': 'Har du en konto?',
  '_dl._qdl': 'Log ind',
  '_dl._srqrmm': 'Indtast venligst for at bekræfte adgangskoden',
  '_dl._sryqm': 'Indtast venligst invitationskoden',
  '_dl._sryzm': 'Indtast venligst bekræftelseskoden',
  '_dl._ljzc': 'Registrer dig nu',
  '_dl._zcbsty': 'Registrering indikerer, at du har læst og accepterer vilkårene',
  '_dl._yszc': 'Privatlivspolitik',
  '_dl._lcmmbyy': 'De to adgangskoder stemmer ikke overens',
  '_yzm._fsyzm': 'Sender bekræftelseskode',
  '_yzm._cxfs': '({time}) Send igen',
  '_yzm._fsz': 'Sender...',
  '_yzm._fscg': 'Sendt med succes',
  '_h._zrm': 'Mest populære',
  '_h._zxd': 'Nyeste',
  '_h._phb': 'Rangering',
  '_h._qz': 'Tapet',
  '_h._ssww': 'Søgning',
  '_h._lsjl': 'Historik',
  '_h._gd': 'Mere',
  '_h._dl': 'Login',
  '_h._ye': 'Saldo',
  '_h._dj': 'Frost',
  '_h._ybp': 'Dashboard',
  '_h._wdqb': 'Min tegnebog',
  '_h._scjl': 'Favoritter',
  '_h._xxzx': 'Beskedcenter',
  '_h._fxhy': 'Del med venner',
  '_h._bzzx': 'Hjælpecenter',
  '_h._ggtf': 'Annoncering',
  '_h._bqtz': 'Ophavsret investering',
  '_h._sz': 'Indstillinger',
  '_sy._jx': 'Udvalgt',
  '_sy._xpfb': 'Nye produktlanceringer',
  '_sy._gdsp': 'Flere videoer',
  '_qz._jbqz': 'Smuk tapetsamling',
  '_qz._ssqz': 'Søg efter baggrunde',
  '_qz._qb': 'Alle',
  '_qz._zrfg': 'Naturlandskab',
  '_qz._cxys': 'Abstrakt kunst',
  '_qz._csjz': 'Byarkitektur',
  '_qz._dmyx': 'Anime og spil',
  '_qz._yzxk': 'Kosmisk rum',
  '_qz._yl': 'Forhåndsvisning',
  '_qz._xzqz': 'Download baggrund',
  '_qz._fbl': 'Opløsning',
  '_qz._fl': 'Kategori',
  '_qz._jzz': 'Indlæser',
  '_qz._myzdpp': 'Ingen matchende baggrunde fundet',
  '_sp._xyjscl': 'Oplåsning kræves for at se',
  '_sp._cz': 'Genoplad',
  '_sp._jsqj': 'Lås alle episoder op',
  '_sp._jsbj': 'Lås denne episode op',
  '_sp._sc': 'Tilføj til favoritter',
  '_sp._fx': 'Del',
  '_sp._jsqjjs': 'Bekræft betaling for {a} og lås alle episoder op?',
  '_sp._jsbjjs': 'Bekræft betaling for {a} og lås denne episode op?',
  '_sp._zfz': 'Betaling i gang...',
  '_sp._qrzf': 'Bekræft betaling',
  '_sp._qx': 'Annuller',
  '_qz._smrc': 'Solopgang over bjerge',
  '_qz._cxjh': 'Abstrakt geometri',
  '_qz._dsyj': 'Byligt nattesyn',
  '_qz._dmfj': 'Anime-landskab',
  '_qz._hhxk': 'Enorm stjernehimmel',
  '_qz._slmw': 'Skovtåge',
  '_qz._scld': 'Farveflow',
  '_qz._xdjz': 'Moderne arkitektur',
  '_qb._cbjl': 'Indbetalingsregistreringer',
  '_qb._jyjl': 'Transaktionsregistreringer',
  '_qb._bddz': 'Bundadresse',
  '_qb._txjl': 'Udbetalingsregistreringer',
  '_m._tcdl': 'Log ud',
  '_m._cb': 'Indbetaling',
  '_m._tb': 'Udbetaling',
  '_cb._ssdz': 'Søg valuta eller adresse',
  '_cb._bz': 'Valuta',
  '_cb._je': 'Beløb',
  '_cb._dz': 'Adresse',
  '_cb._sj': 'Tidspunkt',
  '_cb._cz': 'Handling',
  '_cb._zwjl': 'Ingen transaktionsregistreringer',
  '_cb._dny': 'Side {a} af {b}',
  '_cb._jyxq': 'Transaktionsdetaljer',
  '_cb._jydz': 'Transaktionsadresse',
  '_cb._zt': 'Status',
  '_cb._yqr': 'Bekræftet',
  '_cb._qb': 'Alle',
  '_cb._jt': 'I dag',
  '_cb._j7t': 'Sidste 7 dage',
  '_cb._j30t': 'Sidste 30 dage',
  '_cb._zw': 'Ingen',
  '_cb._fzcg': 'Adresse kopieret til udklipsholder',
  '_jyjl._ssdz': 'Søg valuta eller adresse',
  '_jyjl._lx': 'Type',
  '_jyjl._je': 'Beløb',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Indfrosset',
  '_jyjl._sj': 'Tidspunkt',
  '_jyjl._cz': 'Handling',
  '_jyjl._zwjyjl': 'Ingen transaktionsregistreringer',
  '_jyjl._czsx': 'Nulstil filter',
  '_jyjl._dny': 'Side {a} af {b}',
  '_jyjl._jyxq': 'Transaktionsdetaljer',
  '_jyjl._jylx': 'Transaktionstype',
  '_jyjl._jyje': 'Transaktionsbeløb',
  '_jyjl._jyhye': 'Saldo efter transaktion',
  '_jyjl._djye': 'Indfrosset beløb',
  '_jyjl._jysj': 'Transaktionstidspunkt',
  '_jyjl._jyzt': 'Transaktionsstatus',
  '_jyjl._ywc': 'Afsluttet',
  '_jyjl._qb': 'Alle',
  '_jyjl._jt': 'I dag',
  '_jyjl._j7t': 'De sidste 7 dage',
  '_jyjl._j30t': 'De sidste 30 dage',
  '_jyjl._tp1': 'Indbetaling',
  '_jyjl._tp2': 'Udbetaling',
  '_jyjl._tp3': 'Betaling',
  '_jyjl._tp4': 'Indbetaling',
  '_jyjl._tp5': 'Indfrosset',
  '_jyjl._tp6': 'Indtjening',
  '_jyjl._tp7': 'Invitationsbelønninger',
  '_jyjl._tp8': 'Loginbelønninger',
  '_jyjl._tp9': 'Henvisningsbelønninger',
  '_jyjl._tp10': 'Videovisningsbelønninger',
  '_jyjl._tp11': 'Registreringsbonus',
  '_jyjl._tp12': 'Tilbagetrækning afvist',
  '_jyjl._tp13': 'Rød pakke med besked',

  '_jyjl._tp14': 'Intern overførsel',

  '_cb._shz': 'Under gennemgang',
  '_cb._yyg': 'Godkendt',
  '_cb._ybh': 'Afvist',
  '_bddz._tjdz': 'Tilføj adresse',
  '_bddz._ssdz': 'Søg adresse',
  '_bddz._bz': 'Valuta',
  '_bddz._dz': 'Adresse',
  '_bddz._sysj': 'Brugstid',
  '_bddz._cz': 'Handling',
  '_bddz._zwjl': 'Ingen adresseregistreringer',
  '_bddz._dny': 'Side {a} af {b}',
  '_bddz._dzewm': 'Adresse QR-kode',
  '_bddz._fzdz': 'Kopier adresse',
  '_bddz._dzxq': 'Adresseoplysninger',
  '_bddz._wl': 'Netværk',
  '_bddz._tjsj': 'Tilføjet tid',
  '_bddz._bzwa': 'Bemærkninger',
  '_bddz._ntq': 'For {a} dage siden',
  '_bddz._nxsq': 'For {a} timer siden',
  '_bddz._nfzq': 'For {a} minutter siden',
  '_bddz._ngg': 'Lige nu',
  '_bddz._dzyfz': 'Adressen er kopieret til udklipsholderen',
  '_bddz._scqr': 'Bekræftelse af sletning',
  '_bddz._scqrdz': 'Er du sikker på, at du vil slette denne adresse?',
  '_bddz._qr': 'Bekræft',
  '_bddz._qx': 'Annuller',
  '_bddz._scdzcg': 'Adressen er slettet',
  '_txjl._ztsx': 'Statusfilter',
  '_txjl._qbzt': 'Alle statusser',
  '_txjl._shz': 'Under gennemgang',
  '_txjl._ytg': 'Godkendt',
  '_txjl._yjj': 'Afvist',
  '_txjl._ssdz': 'Søg adresse eller beløb',
  '_txjl._bz': 'Valuta',
  '_txjl._je': 'Beløb',
  '_txjl._dz': 'Adresse',
  '_txjl._zt': 'Status',
  '_txjl._sj': 'Tidspunkt',
  '_txjl._cz': 'Handling',
  '_txjl._zwjl': 'Ingen transaktionsregistreringer',
  '_txjl._czsx': 'Nulstil filter',
  '_txjl._dny': 'Side {a} af {b}',
  '_txjl._jyxq': 'Transaktionsdetaljer',
  '_txjl._skdz': 'Betalingsadresse',
  '_txjl._jysj': 'Transaktionstidspunkt',
  '_txjl._jyzt': 'Transaktionsstatus',
  '_txjl._fzdz': 'Adresse kopieret til udklipsholder',
  '_cbsq._bz': 'Valuta',
  '_cbsq._wl': 'Netværk',
  '_cbsq._erwm': 'QR-kode',
  '_cbsq._fzdz': 'Kopier adresse',
  '_txsq._bz': 'Valuta',
  '_txsq._wl': 'Netværk',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Transaktionsgebyr',
  '_txsq._zxtx': 'Minimumsbeløb for udbetaling',
  '_txsq._txdz': 'Udbetalingsadresse',
  '_txsq._qxztxdz': 'Vælg venligst udbetalingsadresse',
  '_txsq._txje': 'Udbetalingsbeløb',
  '_txsq._qsrtxje': 'Indtast venligst udbetalingsbeløb',
  '_txsq._yxyzm': 'E-mailbekræftelseskode',
  '_txsq._qsryxyzm': 'Indtast venligst bekræftelseskoden',
  '_txsq._ljtx': 'Hæv med det samme',
  '_jl._wxhd': 'Mine favoritter',
  '_jl._lsjl': 'Historik',
  '_xx._bt': 'Beskedcenter',
  '_xx._wjl': 'Ingen poster',
  '_xx._zsmyxx': 'Ingen beskeder i øjeblikket',
  '_xx._sxxx': 'Opdater beskeder',
  '_xx._sxcg': 'Opdatering vellykket',
  '_fx._fxhy': 'Del med venner',
  '_fx._smfx': 'Scan QR-koden for at dele med venner',
  '_fx._jlsm': 'Belønninger forklaring',
  '_fx._jlsm1': '1. For venner, du inviterer direkte, forkortet som niveau 1, vil du modtage {a}% af deres indtjening',
  '_fx._jlsm2': '2. Din niveau 1-ven, hvis de inviterer andre venner (niveau 2), vil du modtage {a}% af deres indtjening.',
  '_fx._jlsm3': '3. Din niveau 2-ven, hvis de inviterer andre venner (niveau 3), vil du modtage {a}% af deres indtjening.',
  '_fx._fzlj': 'Kopier link',
  '_bzzx._bzzx': 'Hjælpecenter',
  '_bzzx._rhzczh': 'Sådan registrerer du en konto',
  '_bzzx._zclc': 'Registreringsproces',
  '_bzzx._rhzcxyh': 'Sådan registrerer du en ny konto?',
  '_bzzx._rhzcxyh1': "Klik på knappen 'Registrer', indtast din e-mailadresse, angiv en adgangskode, og fuldfør e-mailbekræftelsen for at registrere en konto.",
  '_bzzx._rhcz': 'Hvordan fylder man op?',
  '_bzzx._rhcz1': 'Genopladningsproces',
  '_bzzx._rhcz2': 'Detaljerede instruktioner til genopladning',
  '_bzzx._rhcz3': "Klik på 'Min tegnebog', 'Indbetal', vælg den kryptovaluta, du vil indbetale, og overfør den til adressen.",
  '_bzzx._rhjsdj': 'Sådan låser du op for korte dramaer',
  '_bzzx._rhjsdj2': 'Klik på en enkelt episode for at låse op for historien og se mere spændende indhold.',
  '_bzzx._rhtx': 'Sådan hæver du penge fra din konto',
  '_bzzx._rhtx1': "1. Klik på 'Min tegnebog', 'Hæveadresse', og tilføj en tilsvarende hæveadresse til kryptovaluta.<br>2. Klik på 'Hæve', vælg den tilsvarende kryptovaluta, vælg den tilknyttede adresse, indtast hævebeløbet, og vent på, at pengene ankommer.",
  '_bzzx._qtwt': 'Andre spørgsmål',
  '_bzzx._qtwt1': 'Hvordan kontakter jeg kundeservice?',
  '_bzzx._qtwt2': 'Du kan kontakte os via online kundeservice i nederste højre hjørne af webstedet, kundeservice-e-mail eller kundeservice-hotline.',
  '_bzzx._myzdwt': 'Fandt du ikke det svar, du ledte efter?',
  '_bzzx._khjybbzn': 'Vores kundeserviceteam hjælper dig gerne yderligere.',
  '_bzzx._lxkf': 'Kontakt kundeservice',
  '_ggtf._bt1': 'Annonceplacering',
  '_ggtf._splb': 'Videoliste',
  '_ggtf._wcyd': 'Mine deltagelser',
  '_ggtf._hdbm': 'Aktivitetskode',
  '_ggtf._tian': 'Dag',
  '_ggtf._kssj': 'Starttidspunkt',
  '_ggtf._jssj': 'Sluttidspunkt',
  '_ggtf._ddvp': 'Nåede VIP{a}-niveau, gennemsnitlig deltagelse {b} gange pr. person',
  '_ggtf._hdzt': 'Aktivitetsstatus',
  '_ggtf._wks': 'Ikke startet',
  '_ggtf._ycy': 'Deltog',
  '_ggtf._qg': 'Flashsalg',
  '_ggtf._mygdl': 'Ikke flere tilgængelige',
  '_ggtf._qgrtd': 'For mange deltagere, prøv igen',
  '_ggtf._hdxq': 'Aktivitetsdetaljer',
  '_ggtf._hdjs': 'Aktivitetsintroduktion',
  '_ggtf._cyyq': 'Deltagelseskrav',
  '_ggtf._zdtz': 'Minimumsinvestering',
  '_ggtf._vpdj': 'VIP-niveau',
  '_ggtf._rjcy': 'Gennemsnitlig deltagelse pr. person',
  '_ggtf._gmje': 'Købsbeløb',
  '_ggtf._qsrgmje': 'Indtast venligst købsbeløbet',
  '_ggtf._qx': 'Annuller',
  '_ggtf._ljcy': 'Deltag nu',
  '_ggtf._ssjymm': 'Indtast transaktionsadgangskoden',
  '_ggtf._qssjymm': 'Indtast venligst transaktionsadgangskoden',
  '_ggtf._ji': 'Niveau',
  '_ggtf._ci': 'Gange',
  '_ggtf._zdgm': 'Minimumskøbsbeløb',
  '_ggtf._zggm': 'Maksimalt købsbeløb',
  '_ggtf._zfz': 'Betaling i gang...',
  '_wdtg._wjl': 'Ingen deltagerregistreringer endnu',
  '_wdtg._tzje': 'Investeringsbeløb',
  '_wdtg._zsy': 'Samlet indtjening',
  '_wdtg._hdts': 'Antal aktivitetsdage',
  '_wdtg._cysj': 'Deltagelsestid',
  '_wdtg._qzf': 'Fortsæt til betaling',
  '_wdtg._jxz': 'Igangværende',
  '_wdtg._djszje': 'Samlet beløb afventer afregning',
  '_wdtg._gjb': 'Samlede {a} transaktioner',
  '_wdtg._djs': 'Afventer afregning',
  '_wdtg._zrsy': 'Gårsdagens indtjening',
  '_wdtg._dbl': 'Visninger',
  '_wdtg._bfl': 'Afspilninger',
  '_wdtg._wdsy': 'Min indtjening',
  '_wdtg._bqffc': 'Ophavsretsindehaverens andel af omsætning',
  '_wdtg._mr0djs': 'Gårsdagens indtjening afgjort kl. 00:00 dagligt',
  '_wdtg._jrsy': 'Dagens indtjening',
  '_wdtg._mygd': 'Nej mere',
  '_bqyy._bqyy': 'Aftale om ansøgning om ophavsretssamarbejde',
  '_bqyy._qrbq': 'Bekræft ansøgning om ophavsretssamarbejde?',
  '_bqyy._qx': 'Annuller',
  '_bqyy._tjyy': 'Indsend aftale',
  '_bqyy._spsq': 'Aftale om ansøgning om ophavsretssamarbejde for video',
  '_bqyy._spsy': 'Markedsfør dine videoer hos ophavsretsindehavere og generer mere trafik og indtægter!',
  '_bqyy._ljyy': 'Aftale nu',
  '_bqyy._sphz': 'Hvad er en ansøgning om ophavsretssamarbejde for video?',
  '_bqyy._sphzsm': 'En ansøgning om ophavsretssamarbejde for video giver mere salgsfremmende samarbejde med gensidigt fordelagtige resultater. Gennem ansøgningen får du anerkendelse af ophavsretsindehavere og har mulighed for at samarbejde tæt med dem, hvilket giver dig mere eksponering og indtægter.',
  '_bqyy._sqhch': 'Fordele ved at ansøge om ophavsretssamarbejde',
  '_bqyy._llfz': 'Trafikstøtte',
  '_bqyy._llfzsm': 'Få muligheder for platformpromovering, øg eksponering og visninger',
  '_bqyy._sytg': 'Øget omsætning',
  '_bqyy._sytgsm': 'Få højere deling af annonceindtægter og muligheder for forretningssamarbejde',
  '_bqyy._yxhz': 'Prioriteret samarbejde',
  '_bqyy._yxhzsm': 'Prioriteret deltagelse i officielle platformaktiviteter og forretningssamarbejdsprojekter',
  '_bqyy._yytj': 'Reservationskrav',
  '_bqyy._sptg': 'Krav til promovering af videoreklamer',
  '_bqyy._sptgsm': 'Deltag i mindst én platform til videopromoveringsmøder standarder',
  '_bqyy._yysm': "Efter at have klikket på 'Reservation', vil vores personale kontakte dig inden for 3 hverdage",
  '_ybp._wdsy': 'Min omsætning',
  '_ybp._dqye': 'Aktuel saldo',
  '_ybp._jr': 'Dagens',
  '_ybp._jrzsy': 'Dagens samlede indtjening',
  '_ybp._ljzsy': 'Kumuleret samlet indtjening',
  '_ybp._tgfh': 'Henvisningsbonus',
  '_ybp._ljsy': 'Kumuleret indtjening',
  '_ybp._bqsy': 'Ophavsretsindtægt',
  '_ybp._yqfh': 'Henvisningsbonus',
  '_ybp._mrsy': 'Daglig indtjening',
  '_ybp._tgsy': 'Henvisningsindtægter',
  '_tjdz._tjxd': 'Tilføj ny adresse',
  '_tjdz._xzbz': 'Vælg valuta',
  '_tjdz._qbdz': 'Pungadresse',
  '_tjdz._srdz': 'Indtast venligst tegnebogsadresse',
  '_tjdz._qx': 'Annuller',
  '_tjdz._bc': 'Gem',
  '_sz._smrz': 'Autentificering af rigtigt navn',
  '_sz._rzlx': 'Autentificeringstype',
  '_sz._sfzzm': 'ID-foto på forsiden',
  '_sz._sfzfm': 'ID-foto på bagsiden',
  '_sz._zsxm': 'Rigtigt navn',
  '_sz._qsrzsxm': 'Indtast venligst rigtigt navn',
  '_sz._sfzhm': 'ID-kortnummer',
  '_sz._qsrsfzhm': 'Indtast venligst ID-kortnummer',
  '_sz._yyzz': 'Virksomhedslicens',
  '_sz._qymc': 'Virksomhedsnavn',
  '_sz._yyzzh': 'Virksomhedslicensnummer',
  '_sz._qsrqymc': 'Indtast venligst firmanavn',
  '_sz._qsryyzzh': 'Indtast venligst virksomhedslicensnummer',
  '_sz._qx': 'Annuller',
  '_sz._tjrz': 'Send til verifikation',
  '_sz._zt': 'Status',
  '_sz._gr': 'Individuel',
  '_sz._qy': 'Virksomhed',
  '_sz._shz': 'Under gennemgang',
  '_sz._ytg': 'Godkendt',
  '_sz._ybh': 'Afvist',
  '_mm._xgmm': 'Skift adgangskode',
  '_mm._dqxg': 'Skift adgangskode regelmæssigt for at beskytte kontosikkerheden',
  '_mm._dqmm': 'Nuværende adgangskode',
  '_mm._xmm': 'Ny adgangskode',
  '_mm._qrxmm': 'Bekræft ny adgangskode',
  '_mm._qx': 'Annuller',
  '_mm._qrxg': 'Bekræft ændringer',
  '_jymm._xgjymm': 'Skift transaktionsadgangskode',
  '_szzx._sz': 'Indstillinger',
  '_szzx._yrz': 'Godkendt',
  '_szzx._wrz': 'Ikke-godkendt',
  '_szzx._jymm': 'Transaktionsadgangskode',
  '_szzx._szjymm': 'Indstil eller skift transaktionsadgangskode',
  '_szzx._tcdl': 'Log ud af konto',
  '_szzx._qdtcdl': 'Er du sikker på, at du vil logge ud?',
  '_szzx._qrtc': 'Bekræft log ud',
  '_szzx._qx': 'Annuller',

  '_yj._gy': 'Om os',

  '_yj._lxwm': 'Kontakt os',

  '_yj._yszc': 'Privatlivspolitik',

  '_yj._yhxy': 'Brugeraftale',

  '_cd._gszz': 'Virksomhedens kvalifikationer',

  '_cd._wmyy': 'Vi besidder komplette branchekvalifikationer og certificeringer og tilbyder brugerne lovlige, sikre og højkvalitets videotjenester',

  '_cd._yyzz': 'Gyldigt bevis for virksomhedens lovlige drift, der demonstrerer vores formelle registreringsoplysninger og forretningsomfang',

  '_cd._yyzz2': 'En lovligt opnået virksomhedscertificeret forretningslicens, der sikrer platformens lovlighed og overholdelse af regler',

  '_bz._lxkf': 'Klik nedenfor for at kontakte kundeservice, eller kontakt os via kundeservice-e-mail eller hotline',

  '_sz._bjtx': 'Rediger',

  '_sz._bjxx': 'Rediger besked',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Gem',

  '_db._zskf': 'Kontakt kundeservice',
  '_db._zsry': 'Dedikeret support',
  '_db._wdq': 'Ulæst',
  '_db._ydq': 'Læst',

  '_sc._sctp': 'Upload billede',
  '_sc._xztp': 'Vælg billede',
  '_sc._fstp': 'Send billede',
  '_sc._qx': 'Annuller',
  '_sc._hd': 'Okay',

  '_zcyl._zcbt': 'Registreringsbonus',
  '_zcyl._djdkhb': 'Klik for at åbne rød konvolut',
  '_zcyl._zclj': 'Registreringsbelønning',
  '_zcyl._hmyzh': 'Har du ikke en konto?',
  '_zcyl._qzc': 'Registrer',
  '_zcyl._qxdjhb': 'Indløs din belønning først',
  '_zcyl._qwzc': 'Gå til registrering',
  '_zcyl._hbysy': 'Belønning allerede brugt',

  '_ggtg._qhz': 'Gå til overførsel',
  '_ggtg._dqye': 'Nuværende saldo',
  '_ggtg._qcz': 'Gå til opfyldning',
  '_ggtg._hzje': 'Overførselssum',
  '_ggtg._ljhz': 'Overfør nu',
  '_ggtg._yebz': 'Utilstrækkelig saldo',

  '_sq._bhbt': 'Afvist',

  '_sq._bhyy': 'Årsag til afvisning',

  '_xx._ntq': 'For {n} dage siden',

  '_xx._nxsq': 'For {n} timer siden',

  '_xx._nfzq': 'For {n} minutter siden',

  '_xx._nggq': 'Lige nu',

  '_xx._djckgd': 'Klik for at se mere',

  '_ct._zt': 'Status',

  '_ct._ljz': 'Forbinder',

  '_ct._ylj': 'Forbundet',

  '_ct._ltlieb': 'Chatliste',

  '_ct._bnhzj': 'Kan ikke chatte med mig selv',

  '_ct._cylb': 'Medlemsliste',

  '_hb._fhb': 'Rød kuvert',

  '_hb._dqye': 'Aktuel saldo',

  '_hb._fsd': 'Sendt til',

  '_hb._hbje': 'Beløb i rød kuvert',

  '_hb._qshuru': 'Indtast venligst beløb i rød kuvert',

  '_hb._ljfs': 'Send nu',

  '_hb._hbz': 'Rød kuvert Velsignelse',
  '_hb._qshuruzhu': 'Indtast venligst din velsignelse',

  '_sp._cuow': 'Afsnit 1-10 skal låses op, før du kan se dem',

  '_bq._tzzq': 'Investeringsperiode',

  '_bq._zrsy': 'Gårsdagens fortjeneste',

  '_bq._bqtz': 'Ophavsretsinvestering',

  '_bq._tzdj': 'Investeringsbeløb',

  '_bq._zfjz': 'Betaling skal ske inden for 24 timer, ellers vil det blive betragtet som en afkald på betaling!',

  '_bq._qzf': 'Foretag betaling',

  '_bq.jz': 'Frist',

  '_bq._ljzf': 'Betal nu',

  '_bq._sqbz': 'Ansøgningsnoter (valgfrit)',

  '_bq._sqbzsm': 'Indtast venligst ansøgningsnoter',

  '_bq._zzsqz': 'Ophavsretsansøgning igangværende, afventer gennemgang...',

  '_app._xz': 'Download ReelShortBiz-applikationen',

  '_app._smerm': 'Scan QR-koden for at downloade',

  '_app._xzbt': 'Download APP',

  '_m._yhzz': 'Bankoverførsel',
  '_m._yhxx': 'Bankoplysninger',
  '_m._yhmz': 'Banknavn',
  '_m._yhdz': 'Bankadresse',
  '_m._yhmc': 'Navn',
  '_m._yhzh': 'Konto',
  '_m._yhlx': 'Type',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Kode',
  '_m._yhbz': 'Note',
  '_m._fzxx': 'Kopiér info',

  '_m._zts': 'Tips',

  '_m._zyd1': '1. Kontroller venligst omhyggeligt modtagerens navn, kontonummer og bankkode, når du overfører penge. Enhver fejl kan resultere i tab af betalingen.',

  '_m._zyd2': "2. Det anbefales at vælge 'Afsender bærer alle gebyrer' for at undgå utilstrækkelige midler på grund af fradrag fra formidlerbanker.",

  '_m._zyd3': '3. Overførsler tager normalt 1-3 hverdage. Vær tålmodig. Hvis du har spørgsmål, bedes du kontakte kundeservice.',

  '_m._zyd4': '4. Hvis du har andre spørgsmål, bedes du kontakte kundeservice.',

  '_m._jyh': 'Transaktionsnummer',

  '_m._jyje': 'Beløb',

  '_sp._dbye': 'VOD-balancen',
  '_sp.hzye': 'Overførsel',
  '_sp._txje': 'Overførselssum',
  '_sp._qsrtxje': 'Indtast overførselssum',
  '_sp._ljhz': 'Overfør nu',
  '_sp._yebz': 'Utilstrækkelig saldo',
  '_sp._qshuru': 'Indtast den korrekte overførselssum',
  '_sp._fanh': 'Tilbage',

  '_sp._tliu': 'Annonceplacering',
  '_sp._xzgj': 'Vælg land',
  '_sp._cdcw': 'Videokodningsfejl',
  '_ggtf._hot': 'Populær',
  '_tl._tlsj': 'Annoncetid',
  '_tl._xzxb': 'Vælg køn',
  '_tl._nan': 'Mand',
  '_tl._nv': 'Kvinde',
  '_tl._hunhe': 'Blandet',
  '_tl._xznl': 'Vælg alder',
  '_sp._us': 'USA',
  '_sp._en': 'Storbritannien',
  '_sp._jp': 'Japan',
  '_sp._fr': 'Frankrig',
  '_sp._kr': 'Sydkorea',
  '_sp._de': 'Tyskland',
  '_sp._id': 'Indien',
  '_sp._in': 'Indonesien',
  '_sp._au': 'Australien',
  '_sp._es': 'Spanien',
  '_sp._my': 'Malaysia',
  '_sp._cn': 'Kina',
  '_ggtf._fanhui': 'Tilbage',
  '_ggtf._jymmts': 'Bekræft transaktionsbeløbet og indtast din adgangskode',
  '_wdtg._wjl_desc': 'Du har ikke deltaget i nogen reklamekampagner endnu',
  '_wd._jxz': 'I gang',
  '_wd._djs': 'Afventer afregning',
  '_wd._ywc': 'Fuldført',
  '_wd._jz': 'Haster',
  '_wd._hz': 'Overførsel',

  '_tl._tlfbqk': 'Fordeling af annonceudgifter',
  '_tl._tlfbqk_desc': 'Dage 1-5: 5% (Kold startfase), Dage 6-10: 20% (Indholdsvalideringsfase), Dage 11-15: 40% (IP-opbygningsfase), Dage 16-20: 35% (Kort serie-matrixfase)',

  '_nhz._sm': 'Efter overførsel vil beløbet blive overført til videopungen til at låse videoindhold op',
  '_nhz._zhzz': 'Overfører...',
  '_nhz._zzcg': 'Overførsel gennemført',
  '_nhz._zhzsb': 'Overførsel mislykkedes, prøv igen',
  '_m._fzcg': 'Kopieret succesfuldt',
  '_m._fzsb': 'Kopiering mislykkedes, kopier manuelt',
  '_m._zwfzxx': 'Ingen information at kopiere',
  '_tx._qb': 'Alle',
  'activity.detail': 'Aktivitetsdetaljer',
  'activity.noDesc': 'Ingen aktivitetsbeskrivelse',
  'activity.desc': 'Aktivitetsbeskrivelse',
  'activity.requirements': 'Deltagelseskrav',
  'activity.minInvest': 'Minimumsinvestering',
  'activity.vipLevel': 'VIP-niveau',
  'activity.avgParticipation': 'Gennemsnitlig deltagelse',
  'activity.avgParticipationDesc': 'gange',
  'activity.country': 'Vælg land',
  'activity.deliveryTime': 'Annonceringstid',
  'activity.deliveryTimeDesc': 'dage',
  'activity.gender': 'Vælg køn',
  'activity.male': 'Mand',
  'activity.female': 'Kvinde',
  'activity.mixed': 'Blandet',
  'activity.age': 'Vælg alder',
  'activity.amount': 'Købsbeløb',
  'activity.back': 'Tilbage',
  'activity.join': 'Deltag nu',
  emptyData: 'Ingen data',
  emptyDataDesc: 'Ingen deltagende reklamekampagner',
  completedtlement: 'Udløbet',
  preheat: 'Foropvarmning',
  progress: 'I gang',
  settlement: 'Afventer afregning',
  transfered: 'Overført',
  completed: 'Fuldført',
  activityCode: 'Aktivitetskode',
  touzAmount: 'Investeringsbeløb',
  activityDays: 'Aktivitetsdage',
  joinTime: 'Deltagelsestid',
  playSource: 'Afspilningskildefordeling',
  allPlatforms: 'Alle platforme',
  other: 'Andet',
  totalPlayNum: 'Samlede afspilninger',
  incomeSummary: 'Indtægtsoversigt',
  totalPay: 'Betalte ophavsretsgebyrer',
  totalIncome: 'Samlet indkomst',
  copyrightRatio: 'Rettighedshaverandel',
  promotionIncome: 'Promoveringsindtægt',
  copyrightIncome: 'Ophavsretsandel',
  playNum: 'Afspilninger',
  buyNum: 'On-demand afspilninger',
  incomeRate: 'Fordelingsandel',
  yjIncome: 'Estimeret indkomst',
  paid: 'Betalt',
  timeout: 'Tidsudløb',
  transfer: 'Overfør nu',
  loading: 'Indlæser...',
  loadMore: 'Indlæs mere',
  noMore: 'Ikke mere',
  nightTime: 'Natteperiode',
  morningTime: 'Morgenperiode',
  afternoonTime: 'Eftermiddagsperiode',
  eveningTime: 'Aftenperiode',
  '_h._tc': 'Log ud',
  periodPayment: 'Periodebetaling',
  periodPaymentDesc: 'Afregning finder sted 4 gange dagligt i 4 perioder, du kan betale ophavsretsgebyrer pr. periode',

  day: 'dag',
  '_dl._hy': 'Velkommen tilbage',
  '_dl._cj': 'Opret konto',
  '_dl._zmm': 'Nulstil adgangskode',
  '_dl._hyDesc': 'Log ind på din konto for at fortsætte med at udforske fantastisk indhold',
  '_dl._cjDesc': 'Bliv en del af ReelShortBiz og begynd din spændende rejse',
  '_dl._zmmDesc': 'Indtast din e-mail, så sender vi en bekræftelseskode til nulstilling',
  '_dl._hlgqsp': 'Store mængder af HD-film- og videoressourcer',
  '_dl._gxhty': 'Personlige anbefalingsalgoritmer',
  '_dl._ffddsp': 'Rige kortvideoer',
  '_dl._dlzh': 'Log ind',
  '_dl._sdndyx': 'Indtast din e-mail og adgangskode for at fortsætte',
  '_dl._email': 'E-mail-adresse',
  '_dl._qsryx': 'Indtast venligst din e-mail-adresse',
  '_dl._dlmm': 'Adgangskode',
  '_dl._qsrmm': 'Indtast venligst din adgangskode',
  '_dl._wjmm': 'Glemt adgangskode?',
  '_dl._immdl': 'Log ind nu',
  '_dl._hmyzh2': 'Har du ikke en konto?',
  '_dl._ljzc2': 'Tilmeld dig nu',
  '_dl._cjzh': 'Opret konto',
  '_dl._jswmd': 'Bliv en del af ReelShortBiz og begynd din spændende rejse',
  '_zh._qszmm': 'Indstil venligst din adgangskode',
  '_zh._qrmm': 'Bekræft adgangskode',
  '_zh._qmm': 'Indtast venligst adgangskoden igen',
  '_zc._yqm': 'Invitationskode',
  '_zc._sryqm': 'Indtast venligst invitationskoden',
  '_dl._yzm': 'Bekræftelseskode',
  '_dl._qsryzm': 'Indtast venligst bekræftelseskoden',
  '_dl._yjyzh': 'Har du allerede en konto?',
  '_dl._zcbsty2': 'Ved registrering accepterer du',
  '_dl._zcbstyDesc': 'Privatlivspolitik',
  '_dl._newmm': 'Ny adgangskode',
  '_dl._qszxmm': 'Indstil venligst en ny adgangskode',
  '_dl._qrmm': 'Bekræft adgangskode',
  '_dl._qzcsrmm': 'Indtast venligst den nye adgangskode igen',
  '_dl._czmm': 'Nulstil adgangskode',
  '_dl._xqlmm': 'Husket adgangskoden?',
  '_dl._fhdl': 'Tilbage til login',
  '_dl._srdllmmbyz': 'Adgangskoderne stemmer ikke overens',
  '_dl._czcg': 'Adgangskode nulstillet',
  '_h._zc': 'Registrer',
  // '_ybp._wdsy': 'Mine indtægter',
  '_ybp._jrsy': 'Dagens indtægter',
  '_ybp._jztr': 'Sammenlignet med i går',
  '_ybp._bfl': 'Visninger',
  '_ybp._dbl': 'Anmodninger',
  '_ybp._syqs': 'Indtægtstrend',
  // '_ybp._jr': 'I dag',
  '_ybp._t': 'dag',
  // '_ybp._dqye': 'Saldo',
  '_ybp._djs': 'Afventer afregning',
  '_ybp._zhl': 'Konverteringsrate',
  '_ybp._sjgl': 'Dataoversigt',
  '_ybp._zrsy': 'Gårsdagens indtægter',
  '_ybp._bysy': 'Denne måneds indtægter',
  '_ybp._yysj': 'Driftsdata',
  '_ybp._zr': 'I går',
  '_ybp._zjfrs': 'Betalende brugere i alt',
  '_ybp._mtdqje': 'Beløb til udbetaling i morgen',
  '_ybp._jsy': 'Nettoindtægt',
  '_ybp._bqfy': 'Betalingsplan for ophavsretsgebyrer',
  '_ybp._yzf': 'Betalt',
  '_ybp._qzf': 'Gå til betaling',
  '_ybp._bqfyts': 'Efter betaling af ophavsretsgebyrer sikres dine indtægter og rettigheder først',
  '_ybp._syjl': 'Indtægtshistorik',
  '_ybp._ckgd': 'Se mere',
  '_ybp._ssdt': 'Live-opdateringer',
  '_ybp._bzzx': 'Hjælpecenter',
  '_ybp._lxkf': 'Kontakt kundeservice',
  '_ybp._zrxz': 'Gårsdagens indtægter',
  '_ybp._zdsy': 'Samlede indtægter',
  '_ybp._qygy': 'Sidste måned',
  '_ybp._jsjl': 'Afregningshistorik',
  '_ybp._hzjl': 'Overførselshistorik',
  '_ybp._jfzq': 'minutter siden',
  '_ybp._fzq': 'timer siden',
  '_ybp._djs_mt': 'Afregningsbeløb i morgen',
  '_yj._rule': 'Platformregler',

  '_bq._jjks': 'Start nu',
  '_bq._jxz': 'I gang',
  '_bq._jks': 'Tid til start',
  '_bq._jjs': 'Tid til slut',
  '_bq._t': 'd',
  '_bq._h': 't',
  '_bq._m': 'm',
  '_bq._s': 's',
  '_bq._kssj': 'Starttid',
  '_bq._jssj': 'Sluttid',
  '_bqq._tzdj': 'Enhedspris',
  '_bqq._hdts': 'Aktivitetsdage',
  '_bqq._vip': 'VIP-niveau',
  '_bqq._rjcy': 'Gennemsnitlig deltagelse',
  '_bqq._cs': 'gange',
  '_bqq._ysjd': 'Salgsfremskridt',
  '_bqq._ljqg': 'Køb nu',
  '_bqq._zbkqg': 'Ikke tilgængelig i øjeblikket',
  '_bqq._jzz': 'Indlæser',
  '_bqq._jzgd': 'Indlæs mere',
  '_bqq._wz': 'Ikke flere',

  '_sp._gdsj': 'I alt {n} episoder',
  '_sy._jl': 'Afventende afregningspost',
  '_ybp._zsy': 'Samlet indtægt',
  '_ybp._djsjl': 'Afventende afregningspost',
  '_ybp._bqbm': 'Kode',
  '_ybp._je': 'Beløb',
  '_ybp._sj': 'Tid',
  '_sy._djs': 'Afventer',
  '_sy._yjs': 'Afregnet',
  '_sy._gdstjl': 'I alt {n} poster',
  '_sy._gjd': 'I alt {n}',

  '_sp.tgdy':'Beløbet kan ikke være lavere end {a}',
  '_sp.tggy':'Beløbet kan ikke være højere end {a}',

  '_tg._zdyje': 'Brugerdefineret beløb'
}
